import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { getProductById } from "../data/products";
import { useCartStore } from "../store";

export function ProductDetail() {
	const { id } = useParams<{ id: string }>();
	const product = id ? getProductById(id) : undefined;
	const addToCart = useCartStore((s) => s.addToCart);
	const [qty, setQty] = useState(1);
	const [flash, setFlash] = useState(false);

	useEffect(() => {
		if (!flash) return;
		const timer = window.setTimeout(() => setFlash(false), 2000);
		return () => window.clearTimeout(timer);
	}, [flash]);

	if (!product) {
		return (
			<section className="py-16 text-center">
				<h1 className="text-2xl font-semibold text-slate-900">Not found</h1>
				<p className="mt-2 text-slate-600">
					We couldn't find that product.
				</p>
				<Link
					to="/products"
					className="btn-secondary mt-6 inline-block"
					data-testid="detail-back"
				>
					Back to products
				</Link>
			</section>
		);
	}

	const handleAdd = () => {
		addToCart(product.id, Math.max(1, qty));
		setFlash(true);
	};

	return (
		<section className="grid grid-cols-1 md:grid-cols-2 gap-8">
			<div
				className="w-full aspect-square rounded-lg"
				style={{ backgroundColor: product.imageColor }}
				aria-hidden="true"
			/>
			<div className="flex flex-col gap-4">
				<span className="text-xs uppercase tracking-wide text-slate-500">
					{product.category}
				</span>
				<h1 className="text-3xl font-bold text-slate-900">
					{product.name}
				</h1>
				<p className="text-2xl font-semibold text-slate-900">
					${product.price}
				</p>
				<p className="text-slate-700">{product.description}</p>
				<label className="flex items-center gap-3 text-sm">
					<span className="text-slate-700">Quantity</span>
					<input
						type="number"
						min={1}
						value={qty}
						onChange={(event) =>
							setQty(Math.max(1, Number(event.target.value) || 1))
						}
						data-testid="detail-qty"
						className="w-20 rounded-md border border-slate-300 px-3 py-2"
					/>
				</label>
				<button
					type="button"
					onClick={handleAdd}
					data-testid="detail-add-to-cart"
					className="btn-primary w-fit"
				>
					Add to cart
				</button>
				{flash && (
					<div
						role="status"
						data-testid="detail-flash"
						className="rounded-md bg-emerald-100 text-emerald-900 px-3 py-2 text-sm w-fit"
					>
						Added to cart.
					</div>
				)}
			</div>
		</section>
	);
}

export default ProductDetail;
